// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"5077864b","26":"53a8cead","72":"5af5d5b5","87":"53a8cead","249":"b13ac512","776":"3752e884"}[chunkId] + ".chunk.css";
};